/**
 * Gen1 Single relay device template
 * Used by: SHSW-1 (Shelly 1)
 *
 * Gen1 devices use HTTP endpoints instead of RPC
 */

import {
	createGen1TurnAction,
	createGen1StateCondition,
	createGen1StateChangedTrigger,
} from './stateManagement.js';

export function createGen1SingleRelayTemplate() {
	return {
		deviceType: 'gen1_single_relay',
		generation: 1,
		channels: ['relay:0'],
		actions: {
			turn: createGen1TurnAction('relay', false),
		},
		conditions: {
			isOn: createGen1StateCondition('relay'),
		},
		triggers: {
			stateChanged: createGen1StateChangedTrigger('relay'),
		},
	};
}
